module.exports = __webpack_public_path__ + "static/media/mercury-2.729ca47e.jpg";